import {PropType, Frameworks} from '@packages/systems/code-libraries/propTypes';
import {
  ClientCodeModule,
  CodeModuleLoaderType,
} from '@packages/systems/code-modules/core';
import type {CodeLibraryManifest} from '../types';

const pluginId = '690b99dc5e73b9151b3d6b4c';
const profileId = '65f9a5360c82b518950c48f8';
const profileSlug = 'my-code-library';

const manifest: CodeLibraryManifest = {
  name: 'Code Component Sample Library',
  description: 'A library of React components',
  moduleId: pluginId,
  components: [
    {
      id: 'PieChart',
      clientModuleUrl: `https://code-components-acceptance.dev.website-files.com/${pluginId}/module/wf-manifest.json`,
      exportPath: 'default',
      loaderType: CodeModuleLoaderType.FEDERATION,
      framework: Frameworks.React,
      displayName: 'Pie Chart',
      description: 'A simple pie chart',
      group: 'Charts',
      props: [
        {
          name: 'title',
          type: PropType.Text,
          displayName: 'Text/Title',
          tooltip: 'The title of the chart',
        },
        {
          name: 'labels',
          type: PropType.Text,
          defaultValue: 'Dogs, Cats, Fish',
          displayName: 'Text/Labels',
        },
        {
          name: 'titleId',
          type: PropType.Id,
          displayName: 'Title ID',
          tooltip: 'The ID of the title element',
        },
        {
          name: 'link',
          type: PropType.Link,
          displayName: 'Misc/Link',
          tooltip: 'The link to see details',
        },
        {
          name: 'image',
          type: PropType.Image,
          displayName: 'Misc/Image',
          tooltip: 'The image to display',
        },
        {
          name: 'visibility',
          type: PropType.Visibility,
          displayName: 'Misc/Visibility',
          tooltip: 'Whether to show the chart',
        },
        {
          name: 'richText',
          type: PropType.RichText,
          displayName: 'Text/Rich Text',
          tooltip: 'Rich text content',
        },
        {
          name: 'number',
          type: PropType.Number,
          defaultValue: '10',
          displayName: 'Number',
          settings: JSON.stringify({min: 0, max: 100, decimals: 2}),
          tooltip: 'The number to display',
        },
        {
          name: 'variant',
          type: PropType.Variant,
          defaultValue: 'Base',
          displayName: 'Variant',
          settings: JSON.stringify({options: ['Base', 'Dark', 'Light']}),
          tooltip: 'The style variant of the component',
        },
      ],
    },
    {
      id: 'LineChart',
      clientModuleUrl: `https://code-components-acceptance.dev.website-files.com/${pluginId}/module/wf-manifest.json`,
      exportPath: 'default',
      loaderType: CodeModuleLoaderType.FEDERATION,
      framework: Frameworks.React,
      displayName: 'Line Chart',
      description: 'A simple line chart',
      group: 'Charts',
      props: [
        {
          name: 'title',
          type: PropType.Text,
          defaultValue: 'Line Chart',
          displayName: 'Title',
        },
        {
          name: 'labels',
          type: PropType.Text,
          defaultValue: 'Dataset 1, Dataset 2',
          displayName: 'Labels',
        },
        {
          name: 'mySlot',
          type: PropType.Slot,
          displayName: 'Slots/First Slot',
        },
        {
          name: 'mySecondSlot',
          type: PropType.Slot,
          displayName: 'Slots/Second Slot',
        },
        {
          name: 'showSecondSlot',
          type: PropType.Visibility,
          displayName: 'Slots/Show Second Slot',
        },
      ],
    },
    {
      id: 'ButtonWhichThrows',
      clientModuleUrl: `https://code-components-acceptance.dev.website-files.com/${pluginId}/module/wf-manifest.json`,
      exportPath: 'default',
      loaderType: CodeModuleLoaderType.FEDERATION,
      framework: Frameworks.React,
      displayName: 'Button Which Throws',
      description: 'Throws an error after clicking a button',
      group: 'Render states',
      props: [],
    },
    {
      id: 'Button',
      clientModuleUrl: `https://code-components-acceptance.dev.website-files.com/${pluginId}/module/wf-manifest.json`,
      exportPath: 'default',
      loaderType: CodeModuleLoaderType.FEDERATION,
      framework: Frameworks.React,
      displayName: 'Button',
      description: 'Primary button',
      group: 'Call to actions',
      props: [
        {
          name: 'buttonText',
          type: PropType.Text,
          displayName: 'Button text',
          defaultValue: 'Click me',
        },
        {
          name: 'upperCase',
          type: PropType.Boolean,
          displayName: 'Upper case',
          defaultValue: 'false',
          settings: '{"trueLabel":"Enabled","falseLabel":"Disabled"}',
          tooltip: 'Whether to display the button text in upper case',
        },
      ],
    },
    {
      id: 'DatePicker',
      clientModuleUrl: `https://code-components-acceptance.dev.website-files.com/${pluginId}/module/wf-manifest.json`,
      exportPath: 'default',
      loaderType: CodeModuleLoaderType.FEDERATION,
      framework: Frameworks.React,
      displayName: 'Date Picker',
      description: 'A simple date picker',
      group: 'Forms',
      props: [],
    },
    {
      id: 'MaterialUI',
      clientModuleUrl: `https://code-components-acceptance.dev.website-files.com/${pluginId}/module/wf-manifest.json`,
      exportPath: 'default',
      loaderType: CodeModuleLoaderType.FEDERATION,
      framework: Frameworks.React,
      displayName: 'MaterialUI',
      description: 'A simple Rating component from Material UI',
      group: 'Material UI',
      props: [
        {
          name: 'label',
          type: PropType.Text,
          displayName: 'Label',
          defaultValue: 'Material UI Component',
        },
      ],
    },
    {
      id: 'Shadcn',
      clientModuleUrl: `https://code-components-acceptance.dev.website-files.com/${pluginId}/module/wf-manifest.json`,
      exportPath: 'default',
      loaderType: CodeModuleLoaderType.FEDERATION,
      framework: Frameworks.React,
      displayName: 'Shadcn',
      description: 'A simple shadcn component',
      group: 'Shadcn',
      props: [],
    },
    {
      id: 'Tailwind',
      clientModuleUrl: `https://code-components-acceptance.dev.website-files.com/${pluginId}/module/wf-manifest.json`,
      exportPath: 'default',
      loaderType: CodeModuleLoaderType.FEDERATION,
      framework: Frameworks.React,
      displayName: 'Tailwind',
      description: 'A simple tailwind component',
      group: 'Tailwind',
      props: [],
    },
  ],
};

const clientModule: ClientCodeModule = {
  bundleUrl: `https://code-components-acceptance.dev.website-files.com/${pluginId}/module/wf-manifest.json`,
  loaderType: CodeModuleLoaderType.FEDERATION,
};
const codeModule = {id: pluginId, clientModule};

export default {
  pluginId,
  profileId,
  profileSlug,
  manifest,
  codeModule,
};
